import {
  moveAnimationStrategy,
  fadeAnimationStrategy,
  scaleAnimationStrategy,
  rotateAnimationStrategy,
} from "./animationStrategies";

export const animationRegistry = {
  move: moveAnimationStrategy,
  fade: fadeAnimationStrategy,
  scale: scaleAnimationStrategy,
  rotate: rotateAnimationStrategy,
};

export const registerAnimation = (type, strategy) => {
  animationRegistry[type] = strategy;
};
